import type { Distance, PageNumber, Pixel } from "@pdfking/renderer-api"

import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"

export const CreatePdfEngineDefaults = (
  config: Partial<PdfEngineOptions> = {}
): PdfEngineOptions => ({
  file_cache: "pdfengine",
  unit_to_px: 1,
  stroke_width: 1 as Distance,
  image_resolution: 300 as Pixel,
  scale_bleed: 0 as Distance,
  max_split_pages: 999999999 as PageNumber,
  ...config,
})
